module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAbCAMAAABY1h8eAAAAPFBMVEUAAACZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZlr8OySAAAAE3RSTlMA0Sr1ugYR3uUhGO7Cx6ueOT07H7sKoAAAAKFJREFUKM+N0VsOxCAIBVC01qL2NeP+9zrWSK6Fn+GLeKJELrWKVyRd12c0rrpV2V6XPJqqNbQjbpqPWqGwpvfTQGFdybPWfRwsX6K8vTWI+f4TqLFZtXWVueE0Ns0VSzC8jHtGYarWIOYymToFD2ty0aYAg1qzil2zM4qdRdomNTnE/zNKDvZOgT15mE7hJvJlNrxcejKpiEHFmjKbjPixHxBLGKbTOojmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/pop-btn.png
// module id = 71
// module chunks = 0